// extracted by mini-css-extract-plugin
export default {"grid_container":"AllowFeature_grid_container__xph80","grid_item":"AllowFeature_grid_item__+3LOY","grid_text_label":"AllowFeature_grid_text_label__O+exo"};